import { render, staticRenderFns } from "./SelectorFechas.vue?vue&type=template&id=b2b6b128&scoped=true&"
import script from "./SelectorFechas.vue?vue&type=script&lang=js&"
export * from "./SelectorFechas.vue?vue&type=script&lang=js&"
import style0 from "./SelectorFechas.vue?vue&type=style&index=0&id=b2b6b128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b6b128",
  null
  
)

export default component.exports